import { TokenLogout } from "API/Logout/logout";
import axios from "axios";


const url = process.env.REACT_APP_BACKEND_URL



export const GetFosForDropdown = async (setData, setLoading, handleAlertOpen) => {
    setLoading(true);
    try {
        await axios.get(`${url}/map/get_fos_list`, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            }
        }).then((response) => {
            setLoading(false);
            setData(response.data);
        })
    }
    catch (error) {
        setLoading(false);
        console.error("Error fetching FOS for dropdown:", error);
        TokenLogout(error)
        if(error.response && error.response.data.error!=='No FOS Found'){
            handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to fetch fos data", "error");
        }
    }
    finally {
        setLoading(false);
    }
}


export const GetCspForFos=async(page,agent_code,id,mapping_type,setData,setLoading,handleAlertOpen)=>{
    setLoading(true);
    const params={
                page: page,
                fos_id: id,
                mapping_type:mapping_type,
                limit:20
    }

    if(agent_code){
        params["csp_code"]=agent_code
    }
    try {
        await axios.get(`${url}/map/fos_agent_list`, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            },
            params: params
        }).then((response) => {
            setLoading(false);
            setData(response.data);
        })
    }
    catch (error) {
        setLoading(false);
        console.error("Error fetching CSP for FOS:", error);
        TokenLogout(error)
        setData(null);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to fetch csp data", "error");
    }
    finally {
        setLoading(false);
    }

}


export const MapCspToFos = async (fos_id, csp_id, setLoading, handleAlertOpen,handleGet,setSelectedCsps,setSelectAll) => {
    setLoading(true);
    try {
        await axios.post(`${url}/map/fos_with_agent`, {
            fos_id: fos_id,
            agent_id: csp_id
        }, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            }
        }).then((response) => {
            setLoading(false);
            handleAlertOpen(response.data.message, "success");
            setSelectedCsps([]);
            setSelectAll(false);
            handleGet()
        })
    } catch (error) {
        setLoading(false);
        console.error("Error mapping CSP to FOS:", error);
        TokenLogout(error)
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to map CSP to FOS", "error");
    } finally {
        setLoading(false);
    }
}


export const UnMapCspFromFos =async (fos_id, csp_id, setIsLoading, handleAlertOpen, handleGet) =>{
    setIsLoading(true);
    try {
        await axios.post(`${url}/map/unmap_fos_with_agent`, {
            fos_id: fos_id,
            agent_id: csp_id
        }, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            }
        }).then((response) => {
            setIsLoading(false);
            handleAlertOpen(response.data.message, "success");
            handleGet();
        })
    } catch (error) {
        setIsLoading(false);
        console.error("Error unmapping CSP from FOS:", error);
        TokenLogout(error)
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to unmap CSP from FOS", "error");
    } finally {
        setIsLoading(false);
    }
}